export default __webpack_public_path__ + "static/media/profile-pic.60166461.jpg";